import { PropsWithChildren } from "react"
import { Outlet, useOutletContext } from "react-router-dom"

import { MissingPage } from "~/shared/pages/system"
import { useCompanyPaymentsSettingsContext } from "../contexts/CompanyPaymentsSettingsContext"

type Props = {
  /**
   * Use this to render a custom fallback component instead of the MissingPage
   * This can be used to render an old version of the page if the flag is not enabled
   */
  fallback?: JSX.Element
}

export const CompanyPaymentsMandateSetupProtectedRoute = ({
  children,
  fallback,
}: PropsWithChildren<Props>) => {
  const parentContext = useOutletContext()
  const { paymentsMandateSetup } = useCompanyPaymentsSettingsContext()

  const canRenderPage = paymentsMandateSetup === true

  if (!canRenderPage) {
    return fallback ?? <MissingPage />
  }

  return children ? <>{children}</> : <Outlet context={parentContext} />
}
